import { createUseStyles } from 'react-jss'
import style from './style'
import {
  TypographyElement,
  Slider
} from 'UI'
import { chunk } from 'lodash'
import Objective from './Objective'

const useStyle = createUseStyles(style)

const maxNumbersOfObjectivesToShow = 3

const viewObjectives = (view, shadow, splciedObjectives) => splciedObjectives.map((item, key) =>
  (
    <div key={key} className={view}>
      {
        item.map((objective, key) => objective ? <Objective key={key} objective={objective} /> : <div key={key} className={shadow} />)
      }
    </div>
  )
)

export default ({ Objectives = [], id, title }) => {
  const { ObjectivesGroup, motif1, motif2, motif3, motif4, core, view, shadow, controller } = useStyle()
  const splciedObjectives = chunk(Objectives, maxNumbersOfObjectivesToShow).map(chunkObjectives => {
    chunkObjectives.push(...Array(maxNumbersOfObjectivesToShow - chunkObjectives.length))
    return chunkObjectives
  })
  return (
    <div className={ObjectivesGroup}>
      <div className={motif1} />
      <div className={motif2} />
      <div className={motif3} />
      <div className={motif4} />
      <div className={core}>
        <TypographyElement
          Component='h2'
          variant='heading2'
        >
          {title}
        </TypographyElement>
        <Slider
          key={id}
          views={viewObjectives(view, shadow, splciedObjectives)}
          screen='desktop'
          controllerClassName={controller}
          controllerOnTheBottom
          gap={26}
          gapTablet={16}
          gapMobile={16}
        />
      </div>
    </div>
  )
}
